"use client";

import type { BadmintonTemplateData } from "../badminton-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type BadmintonDisplayPreviewProps = {
  data: BadmintonTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function BadmintonDisplayPreview({
  data,
  participants,
}: BadmintonDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="badminton"
        mode="doubles"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants
    .filter((p) => data.positions[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data.positions[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data.hasScore !== false;
  const yourWon = data.matchScore.yourGames > data.matchScore.opponentGames;

  return (
    <div>
      <ActivityCourtPreview
        activityId="badminton"
        data={data}
        mode={data.mode ?? "singles"}
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        showLabels={false}
        linkToProfiles
      />
    </div>
  );
}
